<template>
    <div class="avatar-box m-2 d-flex justify-content-center" v-if="avatar.id">
        <div :id="avatar.id" class="avatar-image position-relative d-flex justify-center align-center">
            <img
                :src="`https://assets.beereaders.com/avatar/${avatar.name}/${avatar.value}`"
                class="avatar-img transition-all"
                @load="handleLoaded"
                alt="Av"
            />
            <v-skeleton-loader
                v-if="!loaded"
                class="rounded-circle position-absolute opacity-none grey lighten-1"
                height="120"
                width="120"
                type="image"
                :transition="'scale-transition'"
            ></v-skeleton-loader>
        </div>
    </div>
</template>

<script>
const defaultAvatar = () => {
    return {
        active: false,
        avatarFormat: '',
        avatarPack: null,
        creationDate: null,
        id: 0,
        name: '',
        ordinalAvatarFormat: 1,
        value: '',
    }
}

export default {
    props: {
        avatar: {
            type: Object,
            default: defaultAvatar,
        },
    },
    data() {
        return {
            loaded: false,
        }
    },
    methods: {
        setActiveAvatar() {
            document.querySelector('.avatar-active').classList.toggle('avatar-active')
            document
                .querySelector(`#${this.avatar.id}`)
                .children()
                .classList.toggle('avatar-active')
        },
        handleLoaded() {
            this.loaded = true
        },
    },
}
</script>

<style lang="css">
.avatar-box,
.avatar-image {
    border-radius: 500px;
}

.avatar-active .avatar-img {
    padding: 0;
}
.avatar-img {
    display: block;
    /* padding: .5vw; */
    width: 100%;
}

.avatar-active {
    border: #514773 1vh;
    border-style: solid;
    /* background-color: #51477341; */
}

.avatar-box,
.avatar-image {
    border-radius: 500px;
}
</style>
